import React, { useImperativeHandle, useRef, useState, useMemo } from 'react';
import clsx from "clsx";
import { indexOf } from 'lodash';
import { Box, Icons, Typography } from '@curves/ui-base';


import RadioChip from "@Local/Dashboard/Components/RadioChip";
const TagSection = React.forwardRef((props, ref) => {
    const { label, tagType, targetType, tagOptions, defaultSelected, disabled } = props;
    const [checkedCount, setCheckedCount] = useState(defaultSelected.length);
    const tagChipRefs = useRef({});
    const iconColor = disabled ? 'gray' : 'primary';
    const handleClickSelectType = () => {
        if (disabled) return;
        if (checkedCount < tagOptions.length) {
            setCheckedCount(tagOptions.length);
            tagOptions.forEach((option) => {
                tagChipRefs.current[option.tagID].setChecked(true);
            });
        } else {
            setCheckedCount(0);
            tagOptions.forEach((option) => {
                tagChipRefs.current[option.tagID].setChecked(false);
            });
        }
    };
    const handleChipChange = () => {
        const newCheckedCount = tagOptions.filter(option => tagChipRefs.current[option.tagID]?.checked()).length;
        setCheckedCount(newCheckedCount);
    };
    const SectionIcon = useMemo(
        () => {
            const props = {
                color: iconColor,
                fontSize: 'small',
                className: clsx('tag-type-selector-box', { 'cursor-pointer': !disabled }),
                onClick: handleClickSelectType
            }
            if (checkedCount === 0) {
                return <Icons.CheckBoxOutlineBlank {...props} />;
            } else if (checkedCount === tagOptions.length) {
                return <Icons.CheckBox {...props} />;
            } else {
                return <Icons.IndeterminateCheckBox {...props} />;
            }
        },
        // eslint-disable-next-line
        [checkedCount, disabled]
    );
    useImperativeHandle(ref, () => ({
        getResult: () => {
            const result = [];
            tagOptions.forEach((option) => {
                const { tagID, tagName } = option;
                if (tagChipRefs.current[tagID].checked())
                    result.push({ targetType, tagType, targetID: tagID, targetName: tagName });
            });
            return result;
        }
    }));
    return (
        <Box>
            <Typography>
                {SectionIcon}
                {label}
            </Typography>
            <Box className="tag-selector-box">
                {tagOptions && tagOptions.length > 0 && (
                    tagOptions.map((option) => {
                        const { tagID, tagName } = option;
                        return (
                            <RadioChip key={tagID}
                                     label={tagName}
                                     defaultChecked={indexOf(defaultSelected, tagID) !== -1}
                                     ref={(el) => (tagChipRefs.current[tagID] = el)}
                                     disabled={disabled}
                                     onChange={handleChipChange}
                            />
                        );
                    })
                )}
            </Box>
        </Box>
    );
});
export default TagSection;